import { NavMenu } from './NavMenu';

export function Layout({ children }: {children: React.ReactNode}) {
    return (
      <div>
        <NavMenu />
        <div className="m-3">
            {children}
        </div>
      </div>
    );
}
